import Vue from 'vue'
export default {
    resetStateMutation(state) {
        Vue.set(state, "formIsOpen", true);
        Vue.set(state, "gridIsOpen", false);
    },
    setFormOpen(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
    },
    setFormClose(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
    }
}
